import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './holidayCalendar.css'; // Import your custom CSS for holiday styling
import { label } from '../utils/style';

const HolidayCalendar = ({ holidays }) => {
  const [date, setDate] = useState(new Date());

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`
  }

  const getHoliday = (date) => {
    console.log(date)
    const formattedDate = formatDate(date)
    console.log(formattedDate)
    return holidays.find(holiday => holiday.date === formattedDate);
  };


  const tileContent = ({ date, view }) => {
    const holiday = getHoliday(date);
    if (view === 'month' && holiday) {
      return <div className="holiday-tile">{holiday.occassion}</div>;
    }
    return null;
  };


  return (
    <div>
      <Calendar
        onChange={setDate}
        value={date}
        tileContent={tileContent}
        tileClassName={({ date, view }) => (getHoliday(date) ? 'highlight-holiday' : null)}
      />
      {
        getHoliday(date) && 
        <p className='py-2'>
          <span className={label}>Holiday: </span>{getHoliday(date).occassion}
        </p>
      }
    </div>
  );
};

export default HolidayCalendar;
